import DeparturesPage from './DeaprturesPage'

export default DeparturesPage
